import { useState } from 'react';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetActivityCodesAliases } from 'api/queries/getActivityCodesAliases.query';

import NoData from 'components/common/NoData/noData';
import MainTable from 'components/common/Tables/MainTable/MainTable';
import { WidgetTitle } from 'components/common/WidgetTitle/WidgetTitle';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { Button } from 'components/DesignSystem/Button';
import classes from 'components/widgets/AliasPreferences/AliasPreferences.module.scss';
import { columns, defaultColumn, initialState } from 'components/widgets/AliasPreferences/AliasPreferences.utils';
import { CreateAliasModal } from 'components/widgets/AliasPreferences/components/CreateAliasModal/CreateAliasModal';

export const AliasPreferences = () => {
    const [showCreateAliasModal, setShowCreateAliasModal] = useState<boolean>(false);

    const { contract } = useProjectTreeStore();
    const {
        data: activityCodesAliasesData,
        isLoading,
        isFetching,
    } = useQueryGetActivityCodesAliases({ contractId: contract?.id });

    const handleCreateAlias = () => {
        setShowCreateAliasModal(true);
    };

    const handleHideCreateAliasModal = () => {
        setShowCreateAliasModal(false);
    };

    return (
        <>
            <WidgetWithTitle
                title={<WidgetTitle title={'Activity Codes Alias'} />}
                titleComponents={[
                    <div className={classes.titleActions}>
                        <Button onClick={handleCreateAlias}>Add Alias</Button>
                    </div>,
                ]}
            >
                <div data-testid={'table-container'} className={classes.tableContainer}>
                    <MainTable
                        columns={columns}
                        data={activityCodesAliasesData?.aliasesList || []}
                        initialState={initialState}
                        defaultColumn={defaultColumn}
                        noData={<NoData>No alias mapping added yet. Click ‘Add Alias’ to add the first one.</NoData>}
                        isLoading={isLoading || isFetching}
                    />
                </div>
            </WidgetWithTitle>

            <CreateAliasModal
                showModal={showCreateAliasModal}
                onHideModal={handleHideCreateAliasModal}
                tableData={activityCodesAliasesData?.aliasesList}
            />
        </>
    );
};
